import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./context/AppContext";

import Login from "./pages/Login";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Sites from "./pages/Sites";
import Profile from "./pages/Profile";
import AdminHome from "./pages/AdminHome";
import CreateClientLogin from "./pages/CreateClientLogin";

import "./assets/styles/global.css";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />

          <Route path="/home" element={<Home />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="admin" element={<AdminHome />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="sites" element={<Sites />} />
            <Route path="profile" element={<Profile />} />
            <Route path="createlogin" element={<CreateClientLogin />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
